import { Controller } from 'stimulus'
import { jsErbCall }  from '@react/helpers/jsErbCall'

const DELAY = 50

export default class extends Controller {
  connect() {
    this.exportId = JSON.parse(this.data.get('export-id'))
    if (this.data.get('dashboard-id')) {
      this.dashboardId = JSON.parse(this.data.get('dashboard-id'))
    }
    this.startPollingAfterDelay(DELAY)
  }

  startPollingAfterDelay(delay) {
    setTimeout(() => {
      this.poll()
      this.pollingInterval = setInterval(() => this.poll(), 3000)
    }, delay)
  }

  disconnect() {
    clearInterval(this.pollingInterval)
  }

  poll() {
    if (this.dashboardId) {
      jsErbCall(`/exports/${this.exportId}/status?dashboard=${this.dashboardId}`)
    } else {
      jsErbCall(`/exports/${this.exportId}/status`)
    }
  }
}